import React, { useEffect } from 'react';
import AppErrorBoundary from '../../../app/features/error/boundary/AppErrorBoundary';
import LAppOnline from '../../../app/layouts/LAppOnline';

const PTestError = () => {
	return (
		<LAppOnline>
			<AppErrorBoundary>
				<CTestError />
			</AppErrorBoundary>
		</LAppOnline>
	);
};

const CTestError = () => {
	useEffect(() => {
		function getRectArea(width: number | string, height: number | string) {
			if (isNaN(Number(width)) || isNaN(Number(height))) {
				throw new Error('Parameter is not a number!');
			}
		}
		getRectArea(3, 'A');
	}, []);

	return <>CTestError</>;
};

export default PTestError;
